var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataIcon03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.914,
    height: 49.983,
    viewBox: "0 0 47.914 49.983",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data_icon03",
    transform: "translate(1.414 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_130",
    "data-name": "\\uD328\\uC2A4 130",
    d: "M144,168.584a2.457,2.457,0,0,1,2.068-1.034h14.477c1.149,0,7.469-6.338,8.273-7.239a55.28,55.28,0,0,0,5.17-8.273A4.139,4.139,0,0,0,169.852,151c-1.828.425-2.9,1.737-4.136,4.136l-4.74,2.461",
    transform: "translate(-128.489 -128.254)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_131",
    "data-name": "\\uD328\\uC2A4 131",
    d: "M150.477,161.239h8.273c4.136,0,4.136-5.17,0-5.17h-5.464c-.861,0-2.477-2.068-3.843-2.068h-5.17a7.231,7.231,0,0,0-4.136,2.068L136,160.2",
    transform: "translate(-128.761 -128.147)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_208",
    "data-name": "\\uC0AC\\uAC01\\uD615 208",
    width: 7.312,
    height: 17.549,
    transform: "translate(0 35.159) rotate(-45)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "\\uC120_32",
    "data-name": "\\uC120 32",
    x2: 1.935,
    y2: 1.935,
    transform: "translate(5.336 35.394)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_132",
    "data-name": "\\uD328\\uC2A4 132",
    d: "M144,152.546V136h8.273",
    transform: "translate(-128.489 -128.761)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_133",
    "data-name": "\\uD328\\uC2A4 133",
    d: "M152,153.818V129h8.273v25.853",
    transform: "translate(-128.216 -129)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_134",
    "data-name": "\\uD328\\uC2A4 134",
    d: "M160,143h8.273v6.2",
    transform: "translate(-127.943 -128.523)",
    fill: "none",
    stroke: "#005ca6",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon03);
export default __webpack_public_path__ + "static/media/data_icon03.17e51d68a0c436f55925ace47eb937e4.svg";
export { ForwardRef as ReactComponent };